import { render, staticRenderFns } from "./LearningSituation.vue?vue&type=template&id=6fe84d7c&scoped=true"
import script from "./LearningSituation.vue?vue&type=script&lang=js"
export * from "./LearningSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe84d7c",
  null
  
)

export default component.exports